import React, { createContext, useContext, useState, useEffect } from 'react';
import { defaultConseils } from '../data/mock';

const ArticlesContext = createContext();

export const useArticles = () => {
  const context = useContext(ArticlesContext);
  if (!context) {
    throw new Error('useArticles must be used within an ArticlesProvider');
  }
  return context;
};

export const ArticlesProvider = ({ children }) => {
  const [articles, setArticles] = useState(() => {
    // Load from localStorage or use default
    const saved = localStorage.getItem('vetordv_articles');
    return saved ? JSON.parse(saved) : defaultConseils;
  });

  // Save to localStorage whenever articles change
  useEffect(() => {
    localStorage.setItem('vetordv_articles', JSON.stringify(articles));
  }, [articles]);

  const addArticle = (article) => {
    const newArticle = {
      ...article,
      id: Date.now(),
      date: new Date().toLocaleDateString('fr-FR', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      })
    };
    setArticles(prev => [newArticle, ...prev]);
    return newArticle;
  };

  const updateArticle = (id, updatedData) => {
    setArticles(prev => 
      prev.map(article => 
        article.id === id ? { ...article, ...updatedData } : article
      )
    );
  };

  const deleteArticle = (id) => {
    setArticles(prev => prev.filter(article => article.id !== id));
  };

  const getArticle = (id) => {
    return articles.find(article => article.id === parseInt(id));
  };

  const resetToDefault = () => {
    setArticles(defaultConseils);
    localStorage.setItem('vetordv_articles', JSON.stringify(defaultConseils));
  };

  return (
    <ArticlesContext.Provider value={{ 
      articles, 
      addArticle, 
      updateArticle, 
      deleteArticle, 
      getArticle,
      resetToDefault 
    }}>
      {children}
    </ArticlesContext.Provider>
  );
};
